<template>
    <div v-if="modal_type === 'confirmation_only'" class="ajaxModal" :id="id+'confirmation'">
        <div class="ajaxModalContainer container">
            <div class="alert alert-confirmation" style="margin-top: 0px;">
                <div class="row confirmationHeader">
                    <div class="col-md-12"><i class="fa fa-exclamation-triangle"></i>
                    </div>
                </div>
                <div class="row confirmationMessageRow">
                    <div class="col-md-12">{{lang('confirmation_new_application')}}</div>
                </div>
                <div class="row confirmationFooter">
                    <div class="col-md-12">
                        <a class="btn btn-success pull-right submitConfirmed_2"
                           href="#"
                           :disabled="processing_request"
                           @click="submitAnswers"><i v-if="processing_request" class="fa fa-spinner fa-spin"></i><span v-else
                                                                                                               v-text="lang('create_application')"></span></a>
                        <a class="btn btn-warning pull-left goBackBtn_2"
                           href="#"
                           :disabled="processing_request"
                           @click="hide()"><i v-if="processing_request" class="fa fa-ban"></i><span v-else
                                                                                                        v-text="lang('no')"></span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="modal fade" ref="modal" :id="id" tabindex="-1" role="dialog" style="z-index:9999">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <span class="modalTitle">{{questionnaireTitle}}</span>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body" style="min-height:205px">
                    <div class="questionnairePreLoader"><!-- Preloader Space --></div>
                    <form class="content-inner" :id="'pre_questionnaire_form'" :name="'pre_questionnaire_form'">
                        <div v-if="user_selected_tenant && currentPage === '0'">
                            <div v-if="valid_parent_option_alliance">
                                <div class="panel-sub-heading headingSmall">
                                    <span class="markedBottom">{{tenantOptions.parent_type.question}}</span>
                                </div>
                                <np-radios
                                        :id="'parent_type'"
                                        :name="'parent_type'"
                                        :required="true"
                                        @input="clearQuestions"
                                        :readonly="!userDetails.partner_access || userDetails.partner_access != '1'"
                                        :label="tenantOptions.parent_type.description"
                                        :options="parentTypeOptions"
                                        v-model="questionnaire.parent_type.value">
                                </np-radios>
                            </div>
                            <div v-if="questionnaire.parent_type.value === 'PARTNER'">
                                <div class="panel-sub-heading headingSmall">
                                    <span class="markedBottom">{{tenantOptions.partner_external_id.question}}</span>
                                </div>
                                <np-select2
                                        :label="tenantOptions.partner_external_id.description"
                                        :id="'partner_external_id'"
                                        :name="'partner_external_id'"
                                        :readonly="isSinglePartner"
                                        :required="true"
                                        @input="clearQuestions"
                                        ref="partner_external_id_input"
                                        :parameters="partnerOptions"
                                        v-model="questionnaire.partner_external_id.value">
                                </np-select2>
                            </div>
                        </div>

                        <div v-if="userQuestions.hasOwnProperty(currentPage)">
                            <div v-for="(questionObj, index) in userQuestions[currentPage]"
                                 v-if="!!questionnaire[questionObj.question_code] && questionnaire[questionObj.question_code].is_relevant">
                                <div class="panel-sub-heading headingSmall">
                                    <span class="markedBottom">{{questionObj.question}}</span>
                                </div>
                                <np-radios v-if="questionObj.answer_type ==='OPTION'"
                                           :id="questionObj.question_code"
                                           :name="questionObj.question_code"
                                           :required="true"
                                           :label="questionObj.description"
                                           :options="questionObj.answer_options"
                                           v-model="questionnaire[questionObj.question_code].value">
                                </np-radios>
                                <np-select2
                                        :mode="questionObj.question_code === 'country_code' ? 'country' : 'normal'"
                                        v-else-if="questionObj.answer_type ==='LIST' || questionObj.answer_type ==='MULTI'"
                                        :label="questionObj.description"
                                        :id="questionObj.question_code"
                                        :name="questionObj.question_code"
                                        :required="true"
                                        :parameters="questionObj.answer_options"
                                        v-model="questionnaire[questionObj.question_code].value">
                                </np-select2>
                                <np-input
                                        v-else
                                        :label="questionObj.description"
                                        :id="questionObj.question_code"
                                        :name="questionObj.question_code"
                                        :required="true"
                                        v-model="questionnaire[questionObj.question_code].value">
                                </np-input>
                            </div>
                        </div>


                        <div v-if="ready_to_submit && currentPage === '-1'">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="panel-sub-heading headingSmall">
                                        <span class="markedBottom">{{lang('summary')}}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="row" v-if="confirmationValues.length > 0">
                                <np-entry v-for="(question) in confirmationValues"
                                          :key="`confirmation_${question.key}`"
                                          :label="question.question"
                                          :model-value="question.answer"
                                >
                                </np-entry>
                            </div>
                        </div>


                    </form>
                </div>
                <div class="modal-footer">
                    <a class="btn btn-danger btn-with-label pull-left"
                       @click="cancel"
                       :disabled="processing_request"><span class="btn-label"><i class="fa fa-times"></i></span><span>{{lang('cancel')}}</span></a>
                    <span class="pagination-block">
                        <span class="pagination-text" v-if="currentPage !== '-1'">{{ paginationText }}</span>
                    </span>
                    <a class="btn btn-default btn-with-label"
                       v-if="showBackButton"
                       @click="backAction"
                       :disabled="processing_request"><span class="btn-label"><i class="fa fa-chevron-left"></i></span>{{lang('back')}}
                    </a>
                    <a class="btn btn-default btn-with-label"
                       v-if="showNextButton"
                       @click="nextAction"
                       :disabled="processing_request">{{lang('next')}}
                        <span class="btn-label"><i class="fa fa-chevron-right"></i></span> </a>
                    <a class="btn btn-success btn-with-label"
                       v-if="ready_to_submit && currentPage === '-1'"
                       @click="submitAnswers"
                       :disabled="processing_request"><span class="btn-label"><i class="fa fa-check"></i></span>
                        {{lang('create_application')}}</a>
                    <!--<a class="btn btn-success btn-with-label" v-if="isConfirming" @click="save" :disabled="submitting"><span class="btn-label"><i :class="{'fa fa-spinner fa-spin': submitting, 'fa fa-check': !submitting}"></i></span> {{questionnaireSaveText}}  </a>-->
                </div>
            </div>
        </div>
    </div>


</template>

<script>
    import {NPModal, NPInput, NPRadios, NPSelect2, NPEntry} from "./index";
    import {Questionnaire, QuestionnaireAnswer, QuestionStructure} from "../../entities/questionnaire";

    export default {
        name: 'np-questionnaire',
        mixins: [NPModal],
        components: {
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-entry': NPEntry,
        },
        props: {
            userDetails: {},
            questionGroupKey: {
                type: String,
                default: 'NEW_APPLICATION'
            },
            partnersInGroupParam: {
                type: Array,
                default: []
            },
        },
        data: function () {
            return {
                error: false,
                valid_parent_option_alliance: true,
                invalid_partners: [],
                is_ready: false,
                payload: {},
                cache: {
                    param: {},
                    tenantParams: {}
                },
                tenantOptions: {
                    partner_external_id: {
                        question: this.lang('partner'),
                        description: this.lang('questionnaire_select_partner')
                    },
                    parent_type: {
                        question: this.lang('parent'),
                        description: this.lang('questionnaire_select_parent')
                    },
                },
                user_selected_tenant: true,
                userQuestions: {}, // UI question_type (has page structure)
                logicQuestions: [], // LOGIC question_type
                preAnsweredQuestions: [], // UI question_type with default answers
                required_params: [], // required param list for each question
                tempUserQuestions: [], // temp storage for user questions while required params are fetched
                currentPage: '0',
                ready_to_submit: false,
                modal_type: 'user_selection',
                processing_request: false,
                questionnaire: new Questionnaire(),
                confirmationValues: [],
                not_valid_elements: []
            }
        },
        mounted: function () {
            this.prepareQuestionnaire();
            $('#pre_questionnaire_form').formValidator({
                //triggerElement: '.sendForm', //trigger element default $('form').find('button[type="submit"]')
                triggerEvent: '', // event - default 'click'
                defaultConfig: '', // {} - object to set different configuration in validate.js
                scrollToError: '', // enable auto-scroll to invalid element default true expect boolean
                additionalCallbackFunction: function () {

                }
            });

        },
        computed: {
            questionnaireTitle: function () {
                return this.lang('prequestionnaire_' + this.questionGroupKey);
            },
            // pageDisplay: function () {
            //     let vm = this,
            //         tot = this.questionPages.length - 1,
            //         curr = this.questionPages.findIndex(obj => {
            //             return obj == vm.currentPage
            //         });
            //     tot = tot >= 0 ? tot : 0;
            //     return curr > 0 && tot > 0 ? String(curr) + ' of ' + String(tot) : '';
            // },
            partnerOptions: function () {
                let invalid = this.invalid_partners;
                let options = [];
                this.partnersInGroupParam.forEach(obj => {
                    let is_invalid = !obj.has_own_workflow || obj.has_own_workflow == '0';
                    let is_invalid2 = !!invalid.find(obj2 => {
                        return obj2 == obj.partner_external_id
                    });
                    if (!is_invalid) {
                        options.push({'id': obj.partner_external_id, 'text': obj.partner_name, disabled: is_invalid2})
                    }
                });
                return options;
            },
            partnersWithWorkflow: function () {
                return this.partnerOptions.filter(obj => {
                    return !obj.disabled;
                })
            },
            isSinglePartner: function () {
                if (!!this.partnerOptions && this.partnerOptions.length === 1) {
                    this.questionnaire.partner_external_id.value = this.user_selected_tenant ? this.partnerOptions[0]['id'] : this.questionnaire.partner_external_id.value;
                    return true;
                }
                return false;
            },
            parentTypeOptions: function () {
                if (this.user_selected_tenant) {
                    if (!this.valid_parent_option_alliance) {
                        this.questionnaire.parent_type.value = 'PARTNER';
                        return [{value: 'PARTNER', label: this.lang('partner')}]
                    }
                    else {
                        return [{
                            value: 'ALLIANCE',
                            label: this.lang('alliance')
                        }, {value: 'PARTNER', label: this.lang('partner')}
                        ]
                    }
                }
                return []
            },
            controller: function () {
                let paths = String(window.location.pathname).split('/');
                return paths.length > 1 ? paths[1] : 'application';
            },
            questionPages: function () {
                let pages = this.user_selected_tenant ? ['0'] : [],
                    q_pages = this.objectIsNotEmpty(this.userQuestions) ? Object.keys(this.userQuestions) : [];
                pages = pages.concat(q_pages);
                pages.push('-1');
                return pages;
            },
            currentPageIndex: function () {
                let vm = this;
                return this.questionPages.findIndex(function(page) {
                    return page === vm.currentPage;
                });
            },
            paginationText: function () {
                return ''; //TODO remove uncommented line
                // return `${(this.currentPageIndex + 1)} ${this.lang('of')} ${this.questionPages.length - 1}`;
            },
            showBackButton: function () {
                let vm = this;
                return this.questionPages.findIndex(obj => {
                    return obj === vm.currentPage
                }) > 0;
            },
            showNextButton: function () {
                return this.currentPage !== '-1';
            },
            confirmationValues: function () {
                let confirmation = [], vm = this;
                if (this.user_selected_tenant) {
                    let answer = vm.parentTypeOptions.find(obj => {
                        return obj.value === vm.questionnaire.parent_type.value
                    });
                    confirmation.push({
                        question: vm.tenantOptions.parent_type.question,
                        answer: !!answer ? answer.label : '',
                        key: 'parent_type'
                    });
                    if (vm.questionnaire.parent_type.value === 'PARTNER') {
                        answer = vm.partnerOptions.find(obj => {
                            return obj.id === vm.questionnaire.partner_external_id.value
                        });
                        confirmation.push({
                            question: vm.tenantOptions.partner_external_id.question,
                            answer: !!answer ? answer.text : '',
                            key: 'partner_external_id'
                        });
                    }
                }
                if (vm.objectIsNotEmpty(vm.userQuestions)) {
                    for (let page_no in vm.userQuestions) {
                        if (vm.userQuestions.hasOwnProperty(page_no)) {
                            vm.userQuestions[page_no].forEach(question => {
                                let model = vm.questionnaire.hasOwnProperty(question.question_code) ? vm.questionnaire[question.question_code] : {};
                                if (!!model.is_relevant) {
                                    let answer = !!model.value ? model.value : '', entry = '';
                                    if (question.answer_type === 'OPTION') {
                                        entry = question.answer_options.find(obj => {
                                            return obj.value == answer
                                        });
                                        answer = !!entry ? entry.label : ''
                                    }
                                    else if (question.answer_type === 'LIST' || question.answer_type === 'MULTI') {
                                        entry = question.answer_options.find(obj => {
                                            return obj.id == answer
                                        });
                                        answer = !!entry ? entry.text : ''
                                    }
                                    confirmation.push({
                                        question: question.question,
                                        answer: answer,
                                        key: question.question_code
                                    });
                                }
                            })
                        }
                    }
                }
                return confirmation
            },

        },
        methods: {
            show: function () {
                if (this.is_ready) {
                    if (this.modal_type === 'confirmation_only') {
                        $(`#${this.id + 'confirmation'}`).css({'display': 'block'});
                    }
                    else {
                        //$(`#${this.id}`).modal('show');
                      let modalEl = document.querySelector(`#${this.id}`)
                      let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
                      modal.show();
                    }
                }
            },
            hide: function () {
               // $(`#${this.id}`).modal('hide');
                let modalEl = document.querySelector(`#${this.id}`)
                let modal = bootstrap.Modal.getOrCreateInstance(modalEl)
                modal.hide();
                $(`#${this.id + 'confirmation'}`).css({'display': 'none'});
            },
            cancel: function () {
                this.clearQuestions();
                this.hide();
            },
            nextAction: function () {
                let vm = this;
                if (this.error) {
                    return false;
                }
                let form = $('#pre_questionnaire_form');
                let is_valid = false;
                if (this.currentPage === '0') {
                    is_valid = this.questionnaire.parent_type.value !== '';
                    if (this.questionnaire.parent_type.value === 'PARTNER') {
                        is_valid = form.find('[name="partner_external_id"]').valid()
                    }
                }
                else {
                    let page_questions = vm.userQuestions[vm.currentPage].filter(obj => {
                        return vm.questionnaire.hasOwnProperty(obj.question_code) && vm.questionnaire[obj.question_code].is_relevant
                    });
                    for (var i = 0; i < page_questions.length; i++) {
                        is_valid = form.find('[name="' + page_questions[i].question_code + '"]').valid() && !!this.questionnaire[page_questions[i].question_code] && this.questionnaire[page_questions[i].question_code].value !== '';
                        if (!is_valid) {
                            break
                        }

                    }
                }
                if (!is_valid) {
                    //console.log('invalid')
                    return is_valid;
                }
                if (this.currentPage === '0' && this.logicQuestions.length === 0 && this.preAnsweredQuestions.length === 0 && this.tempUserQuestions.length === 0) {
                    this.fetchTenantQuestionnaire();
                }
                else {
                    let next = ''
                    let pageIndex = this.questionPages.findIndex(obj => {
                        return obj === vm.currentPage
                    });
                    if (pageIndex < this.questionPages.length - 1) {
                        for (var i = pageIndex + 1; i < this.questionPages.length - 1; i++) {
                            let page_q = vm.userQuestions.hasOwnProperty(vm.questionPages[i]) ? vm.userQuestions[vm.questionPages[i]] : [];
                            if (vm.pageHasRelevantQuestion(page_q)) {
                                next = this.questionPages[i]
                                break;
                            }
                        }
                        if (next === '') {
                            this['currentPage'] = '-1';
                            this.processing_request = false;
                            this.ready_to_submit = true;
                            return true;
                        }
                        this['currentPage'] = next;
                    }
                }
            },
            pageHasRelevantQuestion: function (page_questions) {
                let vm = this;
                return page_questions.filter(obj => {
                    return vm.questionnaire.hasOwnProperty(obj.question_code) && vm.questionnaire[obj.question_code].is_relevant
                }).length > 0;
            },
            backAction: function () {
                let vm = this;
                let pageIndex = this.questionPages.findIndex(obj => {
                    return obj === vm.currentPage
                });
                if (pageIndex > 0) {
                    // this['currentPage'] = this.questionPages[pageIndex - 1];
                    let pages = this.questionPages.slice(0, pageIndex)
                    let prev = ''
                    for (var i = pages.length - 1; i >= 0; i--) {
                        let page_q = vm.userQuestions.hasOwnProperty(pages[i]) ? vm.userQuestions[pages[i]] : [];
                        if (vm.pageHasRelevantQuestion(page_q)) {
                            prev = pages[i]
                            break;
                        }
                    }
                    if (prev === '') {
                        prev = this.questionPages[0]
                    }
                    this['currentPage'] = prev;
                }
            },
            setIsReady: function () {
                if (!this.is_ready) {
                    this.is_ready = true;
                    this.$emit('ready', true);
                }
            },
            banAddAction: function (ban_reason) {
                this.is_ready = false;
                this.$emit('prevent-add', this.lang(ban_reason));
            },
            prepareQuestionnaire: function () {
                this.questionnaire.group_name.value = this.questionGroupKey;
                this.questionnaire.parent_type.value = this.userDetails.parent_type;
                if (this.userDetails.parent_type === 'ALLIANCE') {
                    // alliance only access
                    if (!!this.userDetails.partner_access && this.userDetails.partner_access == '0') {
                        //check that alliance has own workflow
                        if (!this.userDetails.alliance.has_own_workflow && this.userDetails.alliance.has_own_workflow == '0') {
                            this.banAddAction('questionnaire_error_no_work_flow');
                            return false
                        }
                        this.questionnaire.partner_external_id.value = '';
                        this.user_selected_tenant = false;
                    }   // partner only access
                    else if (!!this.userDetails.partner_access && this.userDetails.partner_access == '2') {
                        this.valid_parent_option_alliance = false;
                        this.questionnaire.parent_type.value = 'PARTNER';
                        this.questionnaire.partner_external_id.value = '';
                        if (this.partnersWithWorkflow.length === 0) {
                            this.banAddAction('questionnaire_error_no_partners_in_group');
                            return false
                        }
                        // if more than one partner option is available, allow selection of partner
                        if (this.partnersWithWorkflow.length > 1) {
                            this.setIsReady();
                            return true;
                        }
                        // select single partner by default,
                        this.questionnaire.partner_external_id.value = this.partnersWithWorkflow[0].id;
                        this.user_selected_tenant = false;
                    } else if (!!this.userDetails.partner_access && this.userDetails.partner_access == '1') {
                        //check that alliance has own workflow and at least one partner has workflow
                        if (!this.userDetails.alliance.has_own_workflow && this.userDetails.alliance.has_own_workflow == '0' && this.partnersWithWorkflow.length === 0 ) {
                            this.banAddAction('questionnaire_error_no_work_flow');
                            return false
                        }
                    }
                } // parent type partner
                else {
                    if (!this.userDetails.partner.has_own_workflow && this.userDetails.partner.has_own_workflow == '0') {
                        this.banAddAction('questionnaire_error_no_work_flow');
                        return false
                    }
                    this.questionnaire.partner_external_id.value = this.userDetails.partner_external_id;
                    this.user_selected_tenant = false;
                }
                this.fetchTenantQuestionnaire();
            },
            fetchTenantQuestionnaire: function () {
                let param_payload = {question_group_key: this.questionGroupKey};
                let cache_key = this.questionnaire.parent_type.value + '_' + this.questionnaire.partner_external_id.value;
                this.processing_request = true;
                // use cache if in cache, otherwise, fetch
                if (this.cache.tenantParams.hasOwnProperty(cache_key)) {
                    this.processQuestionnaire(this.cache.tenantParams[cache_key]);
                }
                else {
                    if (this.questionnaire.parent_type.value === 'PARTNER' && this.questionnaire.partner_external_id.value !== '') {
                        param_payload = Object.assign(param_payload, {partner_external_id: this.questionnaire.partner_external_id.value});
                    }
                    this.payload = {
                        param: {
                            TENANT_GROUP_QUESTIONNAIRE: param_payload,
                            TENANT_PROCESS_LIST_PARAM: param_payload
                        }
                    };
                    this.sendRequest('ajaxgetparams', '', this.processQuestionnaire);
                }
            },
            processQuestionnaire: function (data) {
                this.clearQuestions();
                if (data.result == 'SUCCESS') {
                    // store in cache before processing
                    let cache_key = this.questionnaire.parent_type.value + '_' + this.questionnaire.partner_external_id.value;
                    this.cache.tenantParams = Object.assign(this.cache.tenantParams, {[cache_key]: data});
                    let no_workflow = data.TENANT_PROCESS_LIST_PARAM.length === 0,
                        no_questions = data.TENANT_GROUP_QUESTIONNAIRE.length === 0;

                    if (no_workflow || no_questions) {
                        if (!this.user_selected_tenant) {
                            this.banAddAction(no_workflow ? 'questionnaire_error_no_work_flow_config' : 'questionnaire_error_no_question_config');
                            return false
                        }

                        if (this.questionnaire.parent_type.value === 'ALLIANCE') {
                            // user may select other tenants
                            this.valid_parent_option_alliance = false;
                            this.questionnaire.parent_type.value = 'PARTNER';
                            if (!this.is_ready) {
                                // if request is on creation, continue background processes
                                if (this.partnersWithWorkflow.length === 0) {
                                    // no other tenant options available
                                    this.banAddAction(no_workflow ? 'questionnaire_error_no_work_flow_config' : 'questionnaire_error_no_question_config');
                                    return false
                                }

                                // if more than one partner option is available, allow selection of partner
                                if (this.partnersWithWorkflow.length > 1) {
                                    this.processing_request = false;
                                    this.setIsReady();
                                    return true;
                                }

                                // fetch for single partner option
                                this.questionnaire.partner_external_id.value = this.partnersWithWorkflow[0].id;
                                this.user_selected_tenant = false;
                                this.fetchTenantQuestionnaire();
                                return true
                            }
                            this.displayError(no_workflow ? 'questionnaire_error_no_work_flow_config' : 'questionnaire_error_no_question_config');
                            this.processing_request = false;
                            return false
                        }

                        // parent type partner
                        this.invalid_partners.push(this.questionnaire.partner_external_id.value)
                        this.questionnaire.partner_external_id.value = ''
                        this.displayError(no_workflow ? 'questionnaire_error_no_work_flow_config' : 'questionnaire_error_no_question_config');
                        this.processing_request = false;
                        return false;
                    }

                    // In this case, user has both alliance and partner access, and user's alliance
                    // has a valid workflow and questionnaire, we allow the user to select a tenant
                    if (this.user_selected_tenant && !this.is_ready) {
                        this.processing_request = false;
                        this.setIsReady();
                        return true;
                    }

                    let questions = data.TENANT_GROUP_QUESTIONNAIRE, vm = this
                    questions.forEach(question => {
                        question = vm.refineQuestion(question);
                        if (!!question) {
                            vm.tempUserQuestions.push(question);
                        }

                    });
                    if (this.tempUserQuestions.length > 0 && this.required_params.length > 0) {
                        this.payload = {param: this.required_params};
                        this.sendRequest('ajaxgetparams', '', this.handleParamsFetch);

                    }
                    else {
                        vm.setLandingPage();
                    }

                }
                else {
                    //TODO: determine how to manage this error
                    this.displayError(this.lang('error_fetching_questionnaire'), false);
                    return false;
                }

            },
            displayError: function (errorText = this.lang('questionnaire_not_available_' + this.questionGroupKey), error_flag = true) {
                this.modal_type = 'user_selection';
                let errorHtml = objCommon.showCustomErrorMarkup(errorText, 'questionnaireError');
                $('.questionnaireError').remove();
                $('#pre_questionnaire_form').before(errorHtml);
                this.ready_to_submit = false;
                this.error = error_flag;
                this.modal_type = 'user_selection';
                this.processing_request = false;
                this.is_ready = true;
            },
            removeError: function () {
                $('.questionnaireError').remove();
                this.error = false;
            },
            clearQuestions: function () {
                this.removeError();
                this['userQuestions'] = {};
                this.ready_to_submit = false;
                this.preAnsweredQuestions = [];
                this.required_params = [];
                this.logicQuestions = [];
                this.tempUserQuestions = [];
                let vm = this, no_clear = ['parent_type', 'partner_external_id', 'group_name'];
                for (var prop in this.questionnaire) {
                    if (this.questionnaire.hasOwnProperty(prop) && no_clear.findIndex(obj => {
                        return obj === prop
                    }) < 0) {
                        vm.questionnaire[prop] = prop === 'questionnaire_answer' ? [] : new QuestionStructure();
                    }
                }
                vm.currentPage = '0';
            },
            refineQuestion: function (questionObj) {
                let vm = this;
                if (!!questionObj.question_type && questionObj.question_type === 'LOGIC') {
                    vm.logicQuestions.push(questionObj);
                    return false
                }
                if (questionObj.answer_type === 'OPTION' || questionObj.answer_type === 'LIST' || questionObj.answer_type === 'MULTI') {
                    let allowed_values = !!questionObj.allowed_list_values ? String(questionObj.allowed_list_values).split(',') : [];
                    if (allowed_values.length === 1 && vm.questionnaire.hasOwnProperty(questionObj.question_code)) {
                        vm.questionnaire[questionObj.question_code].value = allowed_values[0];
                        questionObj['answer_values'] = allowed_values[0];
                        let q_answer = new QuestionnaireAnswer(questionObj);
                        vm.questionnaire.questionnaire_answer.push(q_answer);
                        vm.preAnsweredQuestions.push(questionObj);
                        return false
                    }
                    // Note: Except for param based questions, list values are the full questionnaire list value model of each allowed value
                    if (questionObj.hasOwnProperty('list_values') && questionObj.list_values.length > 0) {
                        let options = [];
                        if (questionObj.answer_type === 'OPTION') {
                            options = questionObj.list_values.map(list_val => {
                                return {value: list_val.value, label: list_val.text}
                            });
                        }
                        else {
                            options = questionObj.list_values.map(list_val => {
                                return {id: list_val.value, text: list_val.text}
                            });
                        }
                        questionObj['answer_options'] = options;
                    }
                    // will fetch the required params later
                    if (questionObj.hasOwnProperty('param_code') && questionObj.param_code !== '' && !this.cache.param.hasOwnProperty(questionObj.param_code)) {
                        this.required_params.push(questionObj.param_code);
                    }

                }
                return questionObj;
            },
            setQuestionParamOptions: function (questionObj) {
                let options = this.cache.param[questionObj.param_code], vm = this;

                if (questionObj.param_code === 'MERCHANT_HIERARCHY_CONFIGURATION') {
                    options = options.filter(obj => {
                        return (obj.parent_type === vm.questionnaire.parent_type.value)
                            && (obj.alliance_external_id === vm.userDetails.alliance_external_id)
                            && (vm.questionnaire.parent_type.value === 'PARTNER' ? obj.partner_external_id === vm.questionnaire.partner_external_id.value : true);
                    })
                }

                if (!questionObj.hasOwnProperty('all_values_allowed') || questionObj.all_values_allowed == '0') {
                    let allowed_values = !!questionObj.allowed_list_values ? String(questionObj.allowed_list_values).split(',') : [];
                    options = options.filter(obj => {
                        return allowed_values.findIndex(obj2 => {
                            return obj.id == obj2
                        }) >= 0
                    })
                }
                questionObj['answer_options'] = !!options ? options : [];
                return questionObj;
            },
            handleParamsFetch: function (data) {
                let vm = this;
                if (data.result === 'SUCCESS') {
                    for (var param_code in data) {
                        if (param_code !== 'result' && param_code !== 'RESULT' && data.hasOwnProperty(param_code)) {
                            vm.cache.param[param_code] = data[param_code];
                        }
                    }
                }
                this.setLandingPage();
            },
            groupQuestionsToPage: function (data) {
                let vm = this;
                vm.tempUserQuestions.forEach(questionObj => {
                    if (questionObj.hasOwnProperty('param_code') && questionObj.param_code !== '' && vm.cache.param.hasOwnProperty(questionObj.param_code)) {
                        questionObj = vm.setQuestionParamOptions(questionObj);
                    }

                    if (!questionObj.hasOwnProperty('answer_options')) {
                        questionObj['answer_options'] = [];
                    }

                    let page = String(questionObj.page_number);
                    if (vm.userQuestions.hasOwnProperty(page)) {
                        vm.userQuestions[page].push(questionObj);
                    }
                    else {
                        vm.userQuestions[page] = [questionObj];
                    }
                });
            },
            setLandingPage: function () {
                if (this.tempUserQuestions.length === 0 && this.preAnsweredQuestions.length > 0) {
                    this.modal_type = !this.user_selected_tenant ? 'confirmation_only' : 'user_selection';
                    this['currentPage'] = '-1';
                    this.processing_request = false;
                    this.setIsReady();
                    this.ready_to_submit = true;
                    return true;
                }

                this.modal_type = 'user_selection';
                this.groupQuestionsToPage();
                let landing_page = '', vm = this;
                for (var i = 0; i < this.questionPages.length - 1; i++) {
                    let page_q = vm.userQuestions.hasOwnProperty(vm.questionPages[i]) ? vm.userQuestions[vm.questionPages[i]] : [];
                    if (vm.questionPages[i] != '0' && vm.pageHasRelevantQuestion(page_q)) {
                        landing_page = vm.questionPages[i];
                        break;
                    }
                }
                if (landing_page === '') {
                    this['currentPage'] = '-1';
                    this.processing_request = false;
                    this.ready_to_submit = true;
                    this.setIsReady();
                    return true;
                }
                this['currentPage'] = landing_page;
                this.processing_request = false;
                this.setIsReady();
                return true;
            },
            submitAnswers: function () {
                let payload = {};
                let vm = this;
                if (!this.ready_to_submit) {
                    return false;
                }
                for (var question_code in this.questionnaire) {
                    if (this.questionnaire.hasOwnProperty(question_code) && this.questionnaire[question_code].is_relevant && this.questionnaire[question_code].value !== '') {
                        payload[question_code] = this.questionnaire[question_code].value;
                    }
                }
                this.payload = payload;
                let callBack = function (data) {
                    if (data.result === 'SUCCESS') {
                        if (vm.controller === 'application') {
                            const application_reference = data.application.application_reference;
                            window.location.href = '/application/edit/' + application_reference;
                        }
                    }
                    else {
                        window.location.href = '/application/filter';
                    }
                };
                vm.processing_request = true;
                this.sendRequest('add', '', callBack);
            },
            sendRequest: function (action = '', id = '', callback) {
                const vm = this;
                const url = `/${this.controller}/${action}/${id}`;
                this.getAxiosInstance().post(url, this.payload).then(response => {
                    callback(response.data);
                }).catch(error => {
                    //console.log('error')
                    this.processing_request = false;
                });
            },


        },
        watch: {
            'processing_request': function () {
                let loader_space = $('.modal-body .questionnairePreLoader');
                if (this.processing_request) {
                    loader_space.prepend('<div class="gp_mask" style="display: block;"><div class="gp_cont"><div class="gp_box"></div></div></div>');
                }
                else {
                    loader_space.find('.gp_mask').remove();
                }
            },

            'questionnaire.merchant_type.value': function (newValue, oldValue) {
                if (this.questionnaire.hasOwnProperty('mid')) {
                    this.questionnaire.mid.is_relevant = (newValue === 'NO');
                }
                if (this.questionnaire.hasOwnProperty('mcc_code')) {

                    this.questionnaire.mcc_code.is_relevant = (newValue === 'NM');
                }
                if (this.questionnaire.hasOwnProperty('annual_turnover')) {
                    this.questionnaire.annual_turnover.is_relevant = (newValue === 'NM');
                }
            },
            'questionnaire.merchant_hierarchy.value': function (newValue, oldValue) {
                if (this.questionnaire.hasOwnProperty('multiple_outlet')) {
                    let merchantHierarchyConfig = !!this.cache.param.MERCHANT_HIERARCHY_CONFIGURATION
                        ? this.cache.param.MERCHANT_HIERARCHY_CONFIGURATION.find(obj => obj.id === newValue)
                        : {};
                    let isMerchantOutletHierarchy = merchantHierarchyConfig.hasOwnProperty('templates') ? merchantHierarchyConfig.templates.length === 2 : false;  // Merchant -> Outlet
                    if (isMerchantOutletHierarchy) {
                        this.questionnaire.multiple_outlet.is_relevant = true;
                    }
                    else {
                        this.questionnaire.multiple_outlet.is_relevant = false;
                    }
                }
            },

        }

    };
</script>
<style scoped>
    .pagination-block {
        position: absolute;
        width: 60%;
        margin-left: 20%;
        left: 0;
        margin-top: 8px;
    }
    .pagination-block .pagination-text {
        display: inline-block;
        width: 100%;
        text-align: center;
    }
</style>
